<template>
  <div class="home">
<JuegosNavar/>
<JuegoBanner/>
<CategoriasJuegos/>
<JuegosFqa/>
   <FooterSection/>
  </div>
</template>

<script>
import JuegosNavar from '@/components/Juegos/JuegosNavar.vue';
import JuegoBanner from '@/components/Juegos/JuegoBanner.vue';
import CategoriasJuegos from '@/components/Juegos/CategoriasJuegos.vue';
import JuegosFqa from '@/components/Juegos/JuegosFqa.vue';
import FooterSection from '@/components/FooterSection.vue';


export default {
  name: 'HomeView',
  components: {
JuegosNavar,
JuegoBanner,
CategoriasJuegos,
JuegosFqa,
    FooterSection,
  }
}
</script>
